import { useCallback, useContext } from 'react';
import { SelectionContext } from './SelectedBlockInfoProvider';
import { useActiveEditor } from './TiptapEditor/ActiveEditorContext';

/**
 * Deselects the current block and drops the active TipTap editor. The two must
 * happen together: leaving the editor active keeps its selection-highlight
 * decoration painted on the block after it is deselected.
 */
export const useClearBlockSelection = () => {
  const { handleSelectedBlockInfoByWrapper } = useContext(SelectionContext);
  const { setActiveEditor } = useActiveEditor();

  return useCallback(
    (sectionId: string | null = null) => {
      setActiveEditor(null);
      handleSelectedBlockInfoByWrapper({ blockId: null, sectionId });
    },
    [handleSelectedBlockInfoByWrapper, setActiveEditor]
  );
};
